module.exports = __webpack_public_path__ + "img/tops-rondehals.f76eaaec.png";